export default "__VITE_ASSET__44b46851__"